import React from 'react'

export default function HeadingWithIcon({ txt, highlightColor, headerIcon }) {
  let iconBgColor = '#FFF'
  const col = highlightColor ?? ''
  switch (col.toLowerCase()) {
    case '#bed21e':
      iconBgColor = '#318d43'
      break
    case '#6db344':
      iconBgColor = '#235c35'
      break
    case '#01b6d1':
      iconBgColor = '#01496e'
      break
    case '#7de3f4':
      iconBgColor = '#006184'
      break
    case '#ffb81c':
      iconBgColor = '#d45311'
      break
    case '#f68d2e':
      iconBgColor = '#a43500'
      break
    case '#fc4e6d':
      iconBgColor = '#8f124a'
      break
    default:
      break
  }

  const IconImage = () => {
    return headerIcon ?? <></>
  }

  return (
    <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div css={{ display: 'inline-block' }}>
        <div
          css={{
            marginRight: '30px',
            background: highlightColor,
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconImage color={iconBgColor} size="md" />
        </div>
      </div>
      <span css={{ display: 'inline-block' }}>{txt}</span>
    </div>
  )
}
